import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '@shared/services/common-service';
import {
  NotaFiscalSaidaUltimasDestinatarioResponse,
} from '@shared/services/responses/repo-dfe/nota-fiscal-saida-ultimas-destinatario.response';

/** Controller NotaFiscalSaidaLista da API RepoDFe. */
@Injectable({ providedIn: 'root' })
export class NotaFiscalSaidaListaService extends CommonService {
  private readonly apiUrl: string = environment.urlApiRepoDFe + 'NotaFiscalSaidaLista';

  constructor(private httpClient: HttpClient) {
    super();
  }

  /** As últimas NF-e de saída do destinatário, com o status real de cada uma. */
  public getUltimasDoDestinatario(idPessoa: number, quantidade: number = 10): Observable<NotaFiscalSaidaUltimasDestinatarioResponse> {
    return this.httpClient
      .get<NotaFiscalSaidaUltimasDestinatarioResponse>(
        `${this.apiUrl}/destinatario/idPessoa/${idPessoa}/ultimas?quantidade=${quantidade}`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
